/* ============================================================
   MC SEARCH — slide-in search drawer + Shopify predictive search
   ============================================================
   Opens from the header/mobile-drawer search icons. As you type it
   queries Shopify's predictive search JSON (routes.predictive_search_url
   + .json) and renders products / suggestions / collections into the
   reference .search-drawer design. Empty input shows the merchant's
   "Popular searches" + "Trending products". Submitting goes to /search.
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-mc-search-drawer]');
    if (!drawer || drawer.dataset.mcSearchReady === 'true') return;
    drawer.dataset.mcSearchReady = 'true';

    var overlay = document.querySelector('[data-mc-search-overlay]');
    var toggles = document.querySelectorAll('[data-mc-search-toggle]');
    var closers = drawer.querySelectorAll('[data-mc-search-close]');
    var input = drawer.querySelector('[data-mc-search-input]');
    var results = drawer.querySelector('[data-mc-search-results]');
    var defaultPanel = drawer.querySelector('[data-mc-search-default]');
    var status = drawer.querySelector('[data-mc-search-status]');

    var predictiveUrl = drawer.getAttribute('data-predictive-url') || '/search/suggest';
    var searchUrl = drawer.getAttribute('data-search-url') || '/search';
    var moneySymbol = drawer.getAttribute('data-money-symbol') || '';

    var lastFocus = null;
    var debounceTimer = null;
    var abortCtrl = null;

    function setExpanded(state) {
      for (var i = 0; i < toggles.length; i++) {
        toggles[i].setAttribute('aria-expanded', state ? 'true' : 'false');
      }
    }

    function open() {
      lastFocus = document.activeElement;
      // close the mobile nav drawer if it's open (the search icon also lives there)
      var navDrawer = document.querySelector('[data-mc-nav-drawer]');
      var navOverlay = document.querySelector('[data-mc-nav-overlay]');
      if (navDrawer) navDrawer.classList.remove('is-open');
      if (navOverlay) navOverlay.classList.remove('is-open');

      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      // Take the drawer OUT of inert so its contents become keyboard-focusable.
      drawer.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      setExpanded(true);
      setTimeout(function () { if (input) input.focus(); }, 180);
    }

    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setExpanded(false);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      // Make the closed (off-screen) drawer inert so keyboard focus can't land
      // inside it — otherwise Tab disappears into the hidden panel.
      drawer.setAttribute('inert', '');
    }

    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function (e) { e.preventDefault(); open(); });
    }
    for (var j = 0; j < closers.length; j++) {
      closers[j].addEventListener('click', close);
    }
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Focus trap
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var nodes = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* ---- Predictive search ---- */
    function showDefault() {
      if (results) { results.hidden = true; results.innerHTML = ''; }
      if (defaultPanel) defaultPanel.hidden = false;
      // Empty the live region too, so a stale count isn't left behind for a
      // screen reader that re-reads the region on demand.
      if (status) status.textContent = '';
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function group(label, inner) {
      return '<div class="mc-search-drawer__group"><span class="mc-search-drawer__label">' +
        label + '</span>' + inner + '</div>';
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var queries = r.queries || [];
      var collections = r.collections || [];
      var html = '';

      if (queries.length) {
        var chips = queries.slice(0, 5).map(function (item) {
          return '<a href="' + esc(item.url) + '" class="mc-chip">' + esc(item.text) + '</a>';
        }).join('');
        html += group('Suggestions', '<div class="mc-search-drawer__chips">' + chips + '</div>');
      }

      if (products.length) {
        var cards = products.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var imgTag = img
            ? '<img class="mc-search-product__img" src="' + esc(img) + '&width=120" alt="" loading="lazy" width="56" height="56">'
            : '';
          var price = (p.price != null && p.price !== '') ? '<span class="mc-search-product__price">' + esc(moneySymbol + p.price) + '</span>' : '';
          return '<a href="' + esc(p.url) + '" class="mc-search-product">' + imgTag +
            '<span class="mc-search-product__info"><span class="mc-search-product__name">' + esc(p.title) + '</span>' +
            price + '</span></a>';
        }).join('');
        html += group('Products', '<div class="mc-search-drawer__products">' + cards + '</div>');
      }

      if (collections.length) {
        var cchips = collections.slice(0, 4).map(function (c) {
          return '<a href="' + esc(c.url) + '" class="mc-chip">' + esc(c.title) + '</a>';
        }).join('');
        html += group('Collections', '<div class="mc-search-drawer__chips">' + cchips + '</div>');
      }

      if (!products.length && !queries.length && !collections.length) {
        html = '<p class="mc-search-drawer__empty">No results for “' + esc(q) + '”.</p>';
      } else {
        html += '<a href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) +
          '" class="mc-search-drawer__all">View all results for “' + esc(q) + '”</a>';
      }

      if (results) { results.innerHTML = html; results.hidden = false; }
      if (defaultPanel) defaultPanel.hidden = true;
      announce(products.length, queries.length, collections.length, q);
    }

    /* Announce a short count into the live region (4.1.3). Deliberately terse
       — the point is "something happened and here's how much", not a re-read
       of the list, which the user navigates with their own reading keys. */
    function announce(nProducts, nQueries, nCollections, q) {
      if (!status) return;
      var total = nProducts + nQueries + nCollections;
      var msg;
      if (!total) {
        msg = 'No results for ' + q;
      } else {
        var bits = [];
        if (nProducts) bits.push(nProducts + (nProducts === 1 ? ' product' : ' products'));
        if (nCollections) bits.push(nCollections + (nCollections === 1 ? ' collection' : ' collections'));
        if (nQueries) bits.push(nQueries + (nQueries === 1 ? ' suggestion' : ' suggestions'));
        msg = bits.join(', ') + ' for ' + q;
      }
      // Re-typing the same query yields the same string; a live region ignores
      // an unchanged textContent, so clear first to force re-announcement.
      if (status.textContent === msg) status.textContent = '';
      status.textContent = msg;
    }

    function fetchResults(q) {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      var url = predictiveUrl + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query,collection&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { signal: abortCtrl.signal, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
        .then(function (data) { render(data, q); })
        .catch(function (e) { if (!e || e.name !== 'AbortError') showDefault(); });
    }

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(debounceTimer);
        if (q.length < 2) { showDefault(); return; }
        debounceTimer = setTimeout(function () { fetchResults(q); }, 250);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
